import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';
import { ScheduledSms, ScheduleJobInput } from '../models/scheduled-sms.model';
@Injectable({ providedIn: 'root' })
export class ScheduledSmsService {
  private readonly supabase = inject(SupabaseService);
  async create(jobs: ScheduleJobInput[], key: string): Promise<string[]> {
    const { data: session } = await this.supabase.instance.auth.getSession();
    if (!session.session) throw new Error('Sesión inválida.');
    const { data, error } = await this.supabase.instance.functions.invoke(
      'client-schedule-sms',
      {
        body: { jobs, key },
        headers: { Authorization: `Bearer ${session.session.access_token}` }
      }
    );
    if (error) {
      let text = 'No se pudo programar el envío.';
      const response = (error as { context?: Response }).context;
      if (response instanceof Response) {
        const body = await response
          .clone()
          .json()
          .catch(() => null);
        text = body?.error || text;
      }
      throw new Error(text);
    }
    if (!data?.success) throw new Error(data?.error || 'No se pudo programar.');
    return data.ids;
  }
  async list(): Promise<ScheduledSms[]> {
    const { data: session } = await this.supabase.instance.auth.getSession();
    if (!session.session) throw new Error('Sesión inválida.');
    const rows: ScheduledSms[] = [];
    for (let offset = 0; ; offset += 500) {
      const { data, error } = await this.supabase.instance
        .from('scheduled_sms')
        .select('*')
        .eq('user_id', session.session.user.id)
        .order('scheduled_at', { ascending: false })
        .order('id', { ascending: false })
        .range(offset, offset + 499);
      if (error)
        throw new Error('No se pudieron cargar los envíos programados.');
      rows.push(...(data as ScheduledSms[]));
      if (data.length < 500) break;
    }
    return rows;
  }
  async adminList(filters: {tab:string;userId:string;status:string;mode:string;search:string;page:number;pageSize?:number}): Promise<AdminScheduledPage> {
    const {data,error}=await this.supabase.instance.rpc('admin_scheduled_sms',{p_tab:filters.tab,p_user_id:filters.userId||null,p_status:filters.status||null,p_mode:filters.mode||null,p_search:filters.search||null,p_page:filters.page,p_page_size:filters.pageSize ?? 25});
    if(error) throw new Error('No se pudieron cargar los programados. Verifica tus permisos de administrador.');
    return data as AdminScheduledPage;
  }
  async cancel(id: string): Promise<void> {
    const { data, error } = await this.supabase.instance.rpc(
      'cancel_scheduled_sms',
      { p_id: id }
    );
    if (error || data !== true)
      throw new Error(
        'No se pudo cancelar. Es posible que el envío ya haya comenzado.'
      );
  }
}

export interface AdminScheduledSms extends ScheduledSms {user_id:string;client:{full_name:string|null;email:string|null;razon_social:string|null}|null;}
export interface AdminScheduledPage {items:AdminScheduledSms[];total:number;stats:{queued:number;recipients:number;estimated_cost:number;next_at:string|null};}
